import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import { IExamCandidateCreate } from '../../modules/admin/components/IExamCandidateCreate';

const IExamCandidateCreatePage = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>IExamCandidateCreatePage.Bulk Candidate Creation')} />

      <IExamCandidateCreate />
    </>
  );
};

export default IExamCandidateCreatePage;
